import { BufferGeometry, Float32BufferAttribute, Points, PointsNodeMaterial, Vector3 } from 'three/webgpu'
import { float, mod, positionLocal, uniform } from 'three/tsl'
import type { Vec3 } from '../core/math'
import { createRng, range } from '../core/rng'

export interface Dust {
  points: Points
  /** Call every frame with the float64 camera position. */
  update: (cam: Vec3) => void
}

const wrap = (v: number, m: number): number => ((v % m) + m) % m

/** Space dust that tiles around the camera, so speed is visible anywhere in the sector. */
export function createDust(seed: number, count: number, box: number): Dust {
  const rng = createRng(seed ^ 0x5eed)
  const positions = new Float32Array(count * 3)
  for (let i = 0; i < positions.length; i++) positions[i] = range(rng, 0, box)
  const geometry = new BufferGeometry()
  geometry.setAttribute('position', new Float32BufferAttribute(positions, 3))

  const offset = uniform(new Vector3())
  const material = new PointsNodeMaterial({ color: 0x9fb4c8, transparent: true, opacity: 0.6, depthWrite: false })
  material.positionNode = mod(positionLocal.sub(offset), float(box)).sub(box / 2)

  const points = new Points(geometry, material)
  points.frustumCulled = false
  return {
    points,
    // Wrap in float64 first so the float32 uniform stays small (D-011).
    update: (cam: Vec3): void => {
      offset.value.set(wrap(cam.x, box), wrap(cam.y, box), wrap(cam.z, box))
    },
  }
}
